<ul class="snsn_ ul_bread">
  <li *ngFor="let breadcrumb of (breadcrumbs$ | async)">
    <a [href]="breadcrumb.url">{{ breadcrumb.label }}</a>
  </li>
</ul>
